import React, { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { BriefFields, toForm, fromForm } from "./BriefFields";
import { errMsg } from "./utils";

export const NewProjectDialog = ({ open, onOpenChange, onCreated }) => {
  const [form, setForm] = useState(toForm());
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    if (form.client_name.trim().length < 2) return toast.error("Συμπληρώστε το όνομα πελάτη");
    setSaving(true);
    try {
      const { data } = await api.post("/agency/projects", fromForm(form));
      toast.success("Το project δημιουργήθηκε");
      setForm(toForm());
      onCreated(data);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl" data-testid="agency-new-project-dialog">
        <DialogHeader>
          <DialogTitle className="font-['Outfit']">Νέο project πελάτη</DialogTitle>
        </DialogHeader>
        <BriefFields value={form} onChange={setForm} />
        <DialogFooter>
          <Button onClick={submit} disabled={saving} data-testid="agency-create-project-submit">
            {saving ? "Αποθήκευση..." : "Δημιουργία"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
